import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  ListItem,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticTimePicker } from "@mui/x-date-pickers/StaticTimePicker";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import axios from "axios";
import { BaseHrmUrl } from "../../Intro/Constants";

function Attendee(props) {
  const { person, submit } = props;
  const [openDialog, setOpenDialog] = useState(false);
  const [time, setTime] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleMark = () => {
    setOpenDialog(true);
  };

  const handleAcceptTime = (target) => {
    setOpenDialog(false);
    setIsLoading(true);
    //toggle log_in state of user
    
    async function loadData(target) {
      try {
        const response = await axios.post(`${BaseHrmUrl}/attendance/`,
          {user:person.user.username,
            hour:target.$H,
            minute: target.$m,},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
       
      setIsLoading(false);
      if (response.status === 200) {
        person.is_logged_in = !person.is_logged_in;
        submit(person);  
      }
      else {
        alert(response.data.message);
      }
      } catch (error) {
        alert('Internal server error');
      }
    };
  loadData(target)
  }
      

  return (
    <>
      <Card sx={{ width: 250, my: 3 }}>
        <CardContent>
          <Box display={"flex"} justifyContent={"center"} mt={1}>
            <Avatar
              alt="Sample Image"
              src="https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=600"
              sx={{ width:{ xs:64,sm:96,md:128,lg:192}, height: { xs:64,sm:96,md:128,lg:192} }}
            />
          </Box>
          <Box display={"flex"} justifyContent={"center"} mt={1}>
            <Typography variant="subtitle1">
              {person.user.first_name} {person.user.last_name}
            </Typography>
          </Box>
          <Box display={"flex"} justifyContent={"center"} mt={1}>
            <Typography variant="body1">
              {person.section?person.section.department.department:"No Department" } - {person.section?person.section.section:'No Section'}
            </Typography>
          </Box>

          <Box display={"flex"} justifyContent={"center"} mt={1}>
            <LoadingButton
              variant="contained"
              size="small"
              loading={isLoading}
              color={person.is_logged_in ? "error" : "success"}
              sx={{borderRadius:4}}
              onClick={handleMark}
            >
              {person.is_logged_in ? "Log Out" : "Log In"}
            </LoadingButton>
          </Box>
        </CardContent>
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Container components={"StaticTimePicker"}>
              <ListItem label="Static variant">
                <StaticTimePicker
                  defaultValue={dayjs("2022-04-17T08:30")}
                  onAccept={(target) => handleAcceptTime(target)}
                />
              </ListItem>
            </Container>
          </LocalizationProvider>
        </Dialog>
      </Card>
    </>
  );
}

export default Attendee;
